import React, { Component } from "react";
import Input from "../../common/Input";
import { getREDCapSurveyDetails, updateREDCapSurveyDetails } from "../../../services/formService";
import { ToastContainer } from "react-toastify";
import { toaster } from '../../../config';
import { logActivity } from '../../../services/utilService';


export class WREDCapForm extends Component {

    constructor(props) {
        super(props);
        this.state = { REDCap_ID: 0, Survey_ID: null, Display_Name: null };
    }

    async componentDidMount() {
        try {
            //console.log("state", this.props)
            const { data } = await getREDCapSurveyDetails(this.props.Widget.Widget_ID) || {};
            this.setState({ REDCap_ID: data[0].REDCap_ID, Survey_ID: data[0].Survey_ID, Display_Name: data[0].Display_Name });
        }
        catch (e) {
            console.log('Error: ', e);
        }
    }

    handleChange = ({ currentTarget: input }) => {
        this.setState({ [input.name]: input.value });
    }

    async handleSave() {
        let toastType = 'error', toastMsg = 'Please fill in all the fields';
        if (this.state.Display_Name && this.state.Survey_ID) {
            const { data } = await updateREDCapSurveyDetails(this.state.REDCap_ID, this.props.Widget.Widget_ID, this.state.Survey_ID, this.state.Display_Name);
            if (data.includes("Success")) {
                this.setState({ REDCap_ID: data.split(":").pop() });
                toastType = 'success'; toastMsg = 'REDCap Survey info saved successfully';
                logActivity('/formBuilder', 'WIDGET_REDCAPINFO_SAVE_SUCCESS');
            } else {
                toastType = 'error'; toastMsg = data;
                logActivity('/formBuilder', 'WIDGET_REDCAPINFO_SAVE_FAILED');
            }
        }
        toaster(toastType, toastMsg);
    }

    handleRemove() {
        this.props.onRemove(this.props.Widget.Widget_ID);
    }

    render() {
        return (
            <React.Fragment>
                <Input
                    name="Display_Name"
                    value={this.state.Display_Name || ''}
                    label="Display Name"
                    className="form-control"
                    onChange={this.handleChange} />
                <Input
                    name="Survey_ID"
                    value={this.state.Survey_ID || ''}
                    label="Survey ID"
                    className="form-control"
                    onChange={this.handleChange} />
                <div className="float-right">
                    <button className="btn btn-outline-primary m-2" onClick={this.handleSave.bind(this)}> Save </button>
                    <button className="btn btn-outline-danger" onClick={this.handleRemove.bind(this)}> Delete </button>
                </div>
                <ToastContainer />
            </React.Fragment>
        )
    }
}